// components/WarningModal.jsx
export const WarningModal = ({ show, onClose, message }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        animation: "fadeIn 0.3s ease",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "2rem",
          borderRadius: "12px",
          textAlign: "center",
          maxWidth: "400px",
          width: "90%",
          boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
          transform: "translateY(-20px)",
          animation: "slideDown 0.3s forwards",
        }}
      >
        <div
          style={{
            fontSize: "2rem",
            marginBottom: "1rem",
            color: "#ff4d4f",
          }}
        >
          ⚠️ Warning
        </div>
        <p style={{ fontSize: "1rem", color: "#333", marginBottom: "1.5rem" }}>
          {message}
        </p>
        <button
          onClick={onClose}
          style={{
            backgroundColor: "#ff4d4f",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            padding: "0.6rem 1.5rem",
            fontSize: "1rem",
            cursor: "pointer",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#ff7875")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#ff4d4f")}
        >
          OK
        </button>
      </div>

      {/* Animations */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes slideDown {
            from { transform: translateY(-20px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};
